document.addEventListener("DOMContentLoaded", function () {
    const slickSliderBlog = document.querySelector(".featured-articles.slick");
    const arrowsContainer = document.getElementById("blog-slider-arrows");

    if (slickSliderBlog) {
      const slickConfig = {
        dots: false,
        infinite: false,
        speed: 600,
        slidesToShow: 1,
        fade: true,
        touchThreshold: 10,
        adaptiveHeight: true,
        arrows: true,
        prevArrow: '<button type="button" class="slick-arrow slick-prev"></button>',
        nextArrow: '<button type="button" class="slick-arrow slick-next"></button>',
        appendArrows: arrowsContainer,
      };
      $(slickSliderBlog).slick(slickConfig);
    }
    
    var $slider = $('.featured-articles.slick');

      if ($slider) {
        var match = window.location.pathname.match(/\/tagged\/([^\/]+)/);
        if (!match || !match[1]) return; // no tag → show all
    
        var filter = decodeURIComponent(match[1]).toLowerCase();

        // filter slides by tag
        $slider.slick('slickUnfilter'); // reset in case
        $slider.slick('slickFilter', function () {
          var cats = ($(this).data('categories') || '').toString().toLowerCase().split(/\s+/);
          return cats.includes(filter);
        });
    }
  });
  